const reportRoutes =
    [
        {
            path: '/reports',
            name: 'reports',
            component: () => import(/* webpackChunName: "Account" */ './views/reports/index.vue')
        },
        {
            path: '/reportDesign',
            name: 'reportDesign',
            component: () => import(/* webpackChunName: "Account" */ './views/reports/Designer.vue')
        },
        {
            path: '/reportSubscriptions',
            name: 'reportSubscriptions',
            component: () => import(/* webpackChunName: "Account" */ './views/subscriptions/index.vue')
        },
        {
            path: '/subscribe2',
            name: 'ReportSubscriptionCreate',
            component: () => import(/* webpackChunName: "ReportSubscriptionCreate" */ './views/subscriptions/subscribe.vue')
        },
        
        {
            path: '/download',
            name: 'ReportSubscriptionDownload',
            component: () => import(/* webpackChunName: "ReportSubscriptionCreate" */ './views/reportLogs/download.vue')
        },
    ]
export default reportRoutes;